import _ from 'underscore'
import EditSchoolViewTemplate from '../templates/edit-school.tpl'
import Request from '../helpers/request'
import UserModel from '../models/user'
import messages from '../messages'
import Alert from '../helpers/alert'
import UserOptionView from './user-option'
import Backbone from 'backbone'

const EditSchoolView = Backbone.View.extend({
    tagName: 'div',
    id: 'form-view',
    edit: true,
    inputSettings: 'autocomplete=off autocorrect=off autocapitalize=off spellcheck=false',
    events: {
        'click .close': 'close',
        'click .inner-button': 'resetPin',
        'click .submit': 'updateSchool',
    },
    initialize() {
        this.template = _.template(EditSchoolViewTemplate)
    },
    render() {
        this.$el.html(this.template(this.model.toJSON()))

        Request({
            url: '/api/school/teacher',
            method: 'GET',
            data: {
                sort: 'firstnameLowercase lastnameLowercase',
                limit: 500,
            },
        })
            .then((response) => this.listTeachers(response))

        return this
    },
    listTeachers(response) {
        // teacher list
        _.each(response.docs, (userItem) => {
            const userModel = new UserModel({
                id: userItem._id,
                firstname: userItem.firstname,
                lastname: userItem.lastname,
            })
            const userView = new UserOptionView({model: userModel})
            this.$('#super-admin').append(userView.render().el)
        })
    },
    updateSchool() {
        const superAdminId = this.$el.find('#super-admin').val()

        // set the school name
        const name = this.$el.find('#name').val()

        new Promise((resolve, reject) => {
            // checks if name is blank
            if (name.trim() === '') {
                reject(messages.MSG_SCHOOL_NAME_BLANK)
            }
            resolve()
        })
            .then(() => this.model.get('school').update(name))
            .then(() => {
                // if the super admin has changed show warning
                if (superAdminId !== this.model.get('uid')) {
                    return new Promise((resolve, reject) => {
                        const conf = confirm(messages.MSG_CHANGE_SUPER_ADMIN)
                        if (conf) {
                            resolve(true)
                        } else {
                            this.render()
                            reject()
                        }
                    })
                } else {
                    return new Promise((resolve) => resolve(false))
                }
            })
            .then((conf) => {
                // if the user changed the super admin
                // and has confirmed they wish to proceed then change it
                // otherwise continue to the close
                if (conf) {
                    return Request({
                        url: '/api/school/teacher/' + superAdminId + '/super-admin',
                        method: 'PUT',
                        data: {},
                    })
                        .then((response) => {
                            this.model.get('role').set('name', response.user.role)
                            this.model.localSave()
                        })
                } else {
                    return new Promise((resolve) => resolve())
                }
            })
            .then(() => this.close())
            .catch(Alert)
    },
    resetPin() {
        this.model.get('school').resetPin().then(() => this.render())
    },
    close() {
        this.remove()
        this.unbind()
    }
})

export default EditSchoolView
